// test2949
(2949 && 0);
